<template>
  <div v-if="isIndex" style="position: absolute; bottom: 0; left: 0; right: 0; background-color: rgba(255, 255, 255, 0.4); color: #FFF;">
    <div class="copy-right-text" style="display: flex; justify-content: space-between; align-items: center; height: 32px; max-width: 1200px; margin: 0 auto;">
      <div>{{Copyright}}</div>
      <div>
        <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">{{KeepCode}}</a>
      </div>
    </div>
  </div>
  <section v-else id="footer-area" class="footer-area-section">
    <div class="container" style="padding:0px">
      <div class="copy-right-menu">
        <div class="row">
          <div class="col-md-12">
            <div class="copy-right-text" style="display: flex; justify-content: space-between; align-items: center;">
              <p>{{Copyright}}
              </p>
              <p>
                <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">{{KeepCode}}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { ProjectSettings } from '@/views/base/base.js'
export default {
  props: {
    isIndex: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      Copyright: ProjectSettings.Copyright,
      KeepCode: ProjectSettings.KeepCode
    }
  },
  mounted() {
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      console.log('beforeRouteEnter', to);
      console.log('to.name', to.name);
    });
  },

  beforeRouteUpdate(to, from, next) {
    next(vm => {
      console.log('beforeRouteUpdate', to);
      console.log('to.name', to.name);
    });
  }
}
</script>
<style scoped>
.footer-area-section {
  padding: 80px 0px 0px 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/jxsz/footer.vue